import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { withStyles } from '@material-ui/core/styles';


import CarSharingBenefits from './CarSharingBenefits';
import styles from './styles';

const AllServices = ({ partners, loading, classes, onLoad }) => {

  useEffect(() => {
    onLoad();
  }, []);

  return <CarSharingBenefits />;
};

AllServices.propTypes = {
  partners: PropTypes.array,
  loading: PropTypes.bool,
  classes: PropTypes.shape({
    indicator: PropTypes.string.isRequired,
  }).isRequired,
};

AllServices.defaultProps = {
  loading: false,
  partners: [],
};

export default withStyles(styles)(AllServices);
